import HttpService from '@/plugins/http.service'
import Vue from 'vue'

Vue.use(HttpService)

class UploadService {
    upload (form, url, onUploadProgress) {
        const fd = new FormData()
        for (const key in form) {
            // eslint-disable-next-line no-prototype-builtins
            if (key && form.hasOwnProperty(key)) {
                if (key === 'file') {
                    form[key].forEach(file => {
                        fd.append('file[]', file)
                    })
                } else {
                    fd.append(key, form[key])
                }
            }
        }
        return Vue.prototype.$http.post(url, fd, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress
        })
    }
}

export default new UploadService()
